import home from './home'
import error from './error'
import userAdmin from './userAdmin'
import login from './login'
import personalCenter from './personalCenter'
import notification from './notification'
import developer from './developer'
import testRouter from './testRouter'
import debug from './debug'
import reservation from './reservation'
import violation from './violation'
import document from './document'
import wx from './wx'
import ws from './ws'
import vehicleRegister from './vehicleRegister'
import passControl from './passControl'
import personPassControl from './personPassControl'
import messageManagement from './messageManagement'
import statistics from './statistics'
import calculate from './charging'
import pay from './pay'
import park from './park'
import personReservation from './personReservation'
import message from './message'
import school from './school'
export default [
  ...error,
  ...userAdmin,
  ...home,
  ...login,
  ...personalCenter,
  ...notification,
  ...developer,
  ...testRouter,
  ...debug,
  ...reservation,
  ...violation,
  ...document,
  ...wx,
  ...vehicleRegister,
  ...passControl,
  ...messageManagement,
  ...statistics,
  ...calculate,
  ...pay,
  ...park,
  ...personReservation,
  ...personPassControl,
  ...message,
  ...ws,
  ...school
]

// Fixme 整体路由设计问题，不应该把名字放到url里，否则修改名字后会出现一个url不唯一
